import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data.map(({ metadata, ...item }) => {
      return {
        ...item,
        connections: metadata.connections.map(citem => {
          let eitem = item.app.connections.find(
            eitem => eitem.name === citem.id
          )
          return eitem ? { ...citem, ...eitem } : citem
        }),
      }
    })
  }, [data])
}
